export enum OrderIntegration {
  Wolt = 'wolt',
  Jet = 'jet',
  Uber = 'uber',
}
